import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {BaseurlService} from './baseurl.service';
import {AudioRecordingModel} from '../model/AudioRecordingModel';

@Injectable({
  providedIn: 'root'
})
export class AudioRecordingService {

  constructor(
    private http: HttpClient,
    private baseurlService: BaseurlService,
  ) { }

  getAllRecordingEntries(): Observable<AudioRecordingModel[]> {
    return this.http.get<AudioRecordingModel[]>(`${this.baseurlService.getBaseUrl()}/recording/all`);
  }

  getFilteredRecordingEntries(fl: 'first'|'last', nr: number, unreadOnly: boolean): Observable<AudioRecordingModel[]> {
    return this.http.get<AudioRecordingModel[]>(`${this.baseurlService.getBaseUrl()}/recording/filtered/${fl}/${nr}/${unreadOnly}`);
  }

  getSpecificRecording(id: number): Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>(`${this.baseurlService.getBaseUrl()}/recording/${id}`, {responseType: 'arrayBuffer' as 'json'});
  }

  setPlayed(id: number): Observable<AudioRecordingModel> {
    return this.http.put<AudioRecordingModel>(`${this.baseurlService.getBaseUrl()}/recording/${id}/played`, {});
  }
}
